import { fieldsConfigAdmin } from "./leadFields";

export const getTypeByKey = (key) => {

  const field = fieldsConfigAdmin.find(field => field.key === key);


  if (!field) {
    console.warn(`⚠️ Поле с ключом '${key}' не найдено в fieldsConfig`);
    return null;
  }

  return field;
};